import React from 'react';
import '../styles/components/education.css'; 
import { useLanguage } from '../contexts/LanguageContext';

interface EducationData {
  title: string;
  institution: string;
  location: string;
  startDate: string;
  endDate: string;
  description?: string;
  skills?: string[];
}

const Education: React.FC = () => {
  const { t } = useLanguage();
  const educations: EducationData[] = t.education.items;

  return (
    <div className="education-container">
        <div className="header-container">
            <h1 className="section-title">{t.education.title}</h1>
            <p className="section-description">{t.education.description}</p>
      </div>
      <div className="education-grid">
        {educations.map((edu, index) => (
          <div key={index} className={`education-card ${index % 2 === 0 ? 'row' : 'row-reverse'}`}>
            <div className="education-info">
              <h2 className="education-title">{edu.title}</h2>
              <h3 className="education-institution">{edu.institution}</h3>
              <p className="education-location">{edu.location}</p>
              <p className="education-dates">{edu.startDate} - {edu.endDate}</p>
              {edu.description && <p className="education-description">{edu.description}</p>}
              {edu.skills && (
                <ul className="education-skills">
                  {edu.skills.map((skill, i) => (
                    <li key={i} className="education-skill">{skill}</li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Education;
